import { useAppSelector } from '@/store/hooks';
import { selectCurrentWhitelabelWhitelabel } from '@/store/selectors/currentWhitelabel.selectors';
import { ThemeProvider } from '@emotion/react';
import { Skeleton } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AUTH_THEME_TYPE, getCurrentTheme } from '../../theme';
import Copyright from './Copyright';
import LoginBanner from './LoginBanner';

const AuthLayout = () => {
  const { loadingCurrentWhitelabel, whitelabel } = useAppSelector(selectCurrentWhitelabelWhitelabel);
  if (loadingCurrentWhitelabel) {
    return (
      <div className='flex'>
        <div className='w-1/2 p-[24px] h-[100vh]'>
          <Skeleton component='div' sx={{ height: '100%', width: 684, margin: 'auto', transform: 'none' }} />
        </div>
        <div className='w-1/2 m-[24px] justify-center flex flex-col items-center relative'>
          <Skeleton width='50%' height={80} />
          <Skeleton width='50%' height={80} />
          <div className='flex items-center justify-between w-1/2 mb-4'>
            <div className='flex items-center gap-2'>
              <Skeleton variant='rounded' width={16} height={16} />
              <Skeleton variant='text' width={200} />
            </div>
            <Skeleton variant='text' width={200} />
          </div>
          <Skeleton variant='rounded' width='50%' height={48} />
          <Skeleton width={560} variant='text' sx={{ position: 'absolute', bottom: 0 }} />
        </div>
      </div>
    );
  }

  return (
    <ThemeProvider theme={getCurrentTheme(whitelabel, AUTH_THEME_TYPE)}>
      <div className='flex min-h-[100vh] bg-white'>
        <div className='w-1/2 m-[24px] flex justify-center'>
          <LoginBanner logoSrc={whitelabel.mainLogo} showCarousel={whitelabel.isDefault} />
        </div>
        <div className='w-1/2 m-[24px] relative flex items-center justify-center flex-col'>
          <Outlet />
          <Copyright className='absolute bottom-0' />
        </div>
      </div>
    </ThemeProvider>
  );
};

export default AuthLayout;
